import React from "react";
import { Container, Row } from "react-bootstrap";
import { withRouter } from '../Components/WithRouter';
import ContentBlock from '../Components/ContentBlock';

class AcceptPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // paymentId: this.props.match.params.paymentId,
            // token: this.props.match.params.token,
            // PayerID: this.props.match.params.PayerID,
        };
    }

    componentDidMount() {
        console.log(this.props);
        this.props.navigate('/account');
    }

    render() {

        const pageStyle = {
            backgroundImage: "url(kursai-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        return (
            <Container fluid style={pageStyle}>
                <Container>
                    <h1 className="page-title">AcceptPage</h1>
                    <ContentBlock>
                        <h3>Mokėjimas priimtas</h3>
                    </ContentBlock>
                </Container>
            </Container>
        );
    }
}

export default withRouter(AcceptPage);